import React, { Component } from 'react';
import { connect } from 'react-redux';
import PointCauseListWrap from '../../views/point/cause/list/PointCauseListWrap';
import { pointActions } from '../../store/modules/point';
import { POINT_CAUSE_LIST_SEARCH_OPTION_MODEL } from '../../store/modules/point/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';

class PointCauseListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: POINT_CAUSE_LIST_SEARCH_OPTION_MODEL,
      /**
       *  리스트 pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  getList = (data) => {
    const { getPointCauseList, pointCauseList } = this.props;
    const { searchOption, pagination } = pointCauseList;

    getPointCauseList({
      searchOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { pointCauseList, setData } = this.props;

    return <PointCauseListWrap setData={setData} pointCauseList={pointCauseList} getList={this.getList} />;
  }
}

const mapStateToProps = (state) => {
  return {
    pointCauseList: state.point.pointCauseList,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPointCauseList: pointActions.getPointCauseList,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointCauseListContainer);
